export const headerStyle = {
  textAlign: 'center',
  color: '#fff',
  height: 64,
  paddingInline: '1rem',
  lineHeight: '64px',
  backgroundColor: '#4096ff',
  width: '100%',
  display: 'flex',
  justifyContent: 'space-between',
  fontSize: '2em',
};
export const contentStyle = {
  textAlign: 'center',
  // minHeight: 120,
  // lineHeight: '120px',
  // color: '#fff',
  // backgroundColor: '#0958d9',
};
export const siderStyle = {
  textAlign: 'center',
  lineHeight: '120px',
  color: '#fff',
  backgroundColor: '#1677ff',
};
export const footerStyle = {
  textAlign: 'center',
  color: '#fff',
  backgroundColor: '#4096ff',
  fontSize: '1.5em',
  display: 'flex',
  justifyContent: 'space-between',
};
export const layoutStyle = {
  borderRadius: 8,
  overflow: 'hidden',
  width: 'calc(100% - 8px)',
  maxWidth: 'calc(100% - 8px)',
};

